import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PhoneCall } from "lucide-react";

export default function CrisisLine({ dark }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${dark ? "bg-white/10 text-[#FF9E8F] hover:bg-white/20" : "text-[#D64533] hover:bg-[#D64533]/10"}`}
        style={dark ? {} : { background: "#D6453314" }}
        data-testid="crisis-line-btn"
      >
        <PhoneCall size={12} />
        Crisis
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="glass-strong border-white/70 max-w-md rounded-3xl" data-testid="crisis-dialog">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl">Right now matters most</DialogTitle>
            <DialogDescription className="text-[var(--ink-soft)]">
              If you or someone near you is in danger, use these. No sign in, ever.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-3 mt-2">
            <a href="tel:112" className="glass block rounded-2xl p-4 hover:bg-white/90 transition-colors" data-testid="crisis-112">
              <p className="font-semibold">112</p>
              <p className="text-sm text-[var(--ink-soft)]">Emergency services, anywhere in Europe, any hour.</p>
            </a>
            <a href="tel:194" className="glass block rounded-2xl p-4 hover:bg-white/90 transition-colors" data-testid="crisis-194">
              <p className="font-semibold">194</p>
              <p className="text-sm text-[var(--ink-soft)]">Ambulance, Serbia.</p>
            </a>
            <a href="tel:0800300303" className="glass block rounded-2xl p-4 hover:bg-white/90 transition-colors" data-testid="crisis-srce">
              <p className="font-semibold">0800 300 303</p>
              <p className="text-sm text-[var(--ink-soft)]">Centar Srce. Free, anonymous, for the hardest thoughts.</p>
            </a>
          </div>
          <p className="text-xs text-[var(--ink-soft)] mt-1">
            If talking feels impossible right now, going to the nearest emergency room in person also counts.
          </p>
        </DialogContent>
      </Dialog>
    </>
  );
}
